import type { Employee, Location, Organization } from '../model/types';

export interface DuplicateLocationContext {
  location: Location;
  organizationId: string;
}

const hasAccessToAllLocations = (employee: Employee | null): boolean => {
  return !employee || employee.is_owner === true || employee.has_all_locations_access;
};

export const getAccessibleLocations = (
  organizations: readonly Organization[],
  employee: Employee | null,
  onDuplicateLocation?: (context: DuplicateLocationContext) => void,
): Location[] => {
  const allowedLocationIds = employee && !hasAccessToAllLocations(employee) ? new Set(employee.location_ids) : null;
  const seenLocationIds = new Set<string>();
  const locations: Location[] = [];

  for (const organization of organizations) {
    for (const location of organization.locations ?? []) {
      if (allowedLocationIds && !allowedLocationIds.has(location.id)) {
        continue;
      }

      if (seenLocationIds.has(location.id)) {
        onDuplicateLocation?.({
          location,
          organizationId: organization.id,
        });
        continue;
      }

      seenLocationIds.add(location.id);
      locations.push(location);
    }
  }

  return locations;
};

export const getLocationOrganizationMap = (organizations: readonly Organization[]): Map<string, string> => {
  const map = new Map<string, string>();

  for (const organization of organizations) {
    for (const location of organization.locations ?? []) {
      if (!map.has(location.id)) {
        map.set(location.id, organization.id);
      }
    }
  }

  return map;
};
